/**
 * Central fallback logic for null, undefined, and empty values
 *
 * This is the SINGLE SOURCE OF TRUTH for all fallback handling in the backend table system.
 * All components must use this function instead of implementing their own fallback logic.
 */
export const getFallbackValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return String(value);
};
